import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { ProjectRenderer } from '../ProjectRenderer';

export enum ExportType {
	GLTF = 'gltf',
}

export class Exporter {
	private gltfExporter = new GLTFExporter();

	constructor(private renderer: ProjectRenderer) {}

	async exportProject(type: ExportType) {
		switch (type) {
			case ExportType.GLTF:
				return await this.exportGLB();

			default:
				throw new Error('UNKNOWN_EXPORT_TYPE');
		}
	}

	private async exportGLB() {
		const buffer = await this.gltfExporter.parseAsync(this.renderer.project, {
			binary: true,
		});

		return buffer as ArrayBuffer;
	}
}
